package data.mapper

import ui.theme.ThemeMode

/**
 * Mapper for ThemeMode domain object to/from storage strings
 */
object ThemeMapper {
    
    /**
     * Map storage string to ThemeMode domain object
     */
    fun fromStorage(storageValue: String?): ThemeMode {
        return when (storageValue?.uppercase()) {
            "DARK" -> ThemeMode.DARK
            "LIGHT" -> ThemeMode.LIGHT
            "AUTO" -> ThemeMode.AUTO
            else -> ThemeMode.LIGHT // Default to light theme
        }
    }
    
    /**
     * Map ThemeMode domain object to storage string
     */
    fun toStorage(themeMode: ThemeMode): String {
        return themeMode.name
    }
}
